import { orderConstants } from './constants/orderConstants'

 const orderGetByFilter = (input) => {
	return {
		type: orderConstants.OrderGetByFilterRequest,
		input: input
  };
};

 const orderRecurringGetByFilter = (input) => {
	return {
		type: orderConstants.OrderRecurringGetByFilterRequest,
		input: input
	};
};

export const orderAction = {
	orderGetByFilter,
	orderRecurringGetByFilter
}